class Interceptor {
  next: any;

  intercept = (res: any, http: any) => {
    const result = this.onIntercept(res, http);
    if (this.next) return this.next.intercept(result, http);
    return result;
  };

  onIntercept = (_: any, _http?: any): any => {
    throw Error('Implementation is needed');
  };
}

const createInterceptorChain = (interceptors: Interceptor[]) => {
  if (!Array.isArray(interceptors)) return Error('expect an array');

  if (interceptors.length === 0) return null;

  for (let i = 0; i < interceptors.length; i++) {
    const nextIndex = i + 1;
    if (nextIndex === interceptors.length) {
      break;
    }

    const interceptor = interceptors[i];
    interceptor.next = interceptors[nextIndex];
  }

  return interceptors[0];
};

export { Interceptor, createInterceptorChain };
